import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsImage } from "react-icons/bs";
import useDialogState, { Loader } from "../../hook";
import Parallax4DImageService from "../../services/parallax4D.service";
import { notifyError, notifySuccess } from "../../hook/notification";
import * as yup from "yup";
import CategoryService from "../../services/category.service";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import liveWallpaperService from "../../services/livewallpaper.service";
import NotificationService from "../../services/notification.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const MultiWallpaper = () => {
  const menuRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [data, setData] = useState([]);
  const [showVal, setShowVal] = useState("NON PREMIUM");
  const [showVal2, setShowVal2] = useState("");
  const [showVal3, setShowVal3] = useState("");
  const [fileName, setFileName] = useState(["", "", ""]);
  const [fileNamePreview, setFileNamePreview] = useState([]);
  const [updateId, setUpdateId] = useState([]);
  const [notification, setNotification] = useState(false);
  const [imageUpdate, setImageUpdate] = useState(false);
  const [collectionData, setCollectionData] = useState([]);

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  const handleSelect = (value, id) => {
    setShowVal(value);
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
  };

  const handleSelect2 = (value, id) => {
    setShowVal2(value);
    formik.setFieldValue("categoryId", id);
  };

  const handleSelect3 = (value, id) => {
    setShowVal3(value);
    formik.setFieldValue("collectionId", id);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleClickLayer = (layerIndex) => {
    const inputRef = document.getElementById(`file-input-${layerIndex}`);
    inputRef.click();
  };

  const handleChange = (event, index) => {
    setImageUpdate(true);
    const fileUploaded = event.target.files[0];
    setFileName((prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    formik.setFieldValue("multiFile", (prev) => {
      const updatedImages = [...prev];
      updatedImages[index] = fileUploaded;
      return updatedImages;
    });
    setUpdateId((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  const handleChangePreview = (event) => {
    const fileUploaded = Array.from(event.target.files);
    formik.setFieldValue("previewImage", fileUploaded);
    setFileNamePreview(fileUploaded);
  };

  const ImageType = [
    { value: "PREMIUM", label: "PREMIUM" },
    { value: "NON PREMIUM", label: "NON PREMIUM" },
  ];

  const getAllData = async () => {
    const response = await CategoryService.GetAllCategory(0, 0);
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollectionData = async () => {
    try {
      const response = await CollectionService.GetAllCollection(0, 0);
      const data = response.data.apiresponse.data;
      setCollectionData(data?.collections);
    } catch (error) {
      console.log("🚀  getAllCollectionData  error:", error);
    }
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  useEffect(() => {
    if (location.state !== null && CategoryOption.length > 0) {
      const data = location.state;
      const abcd = CategoryOption.find(
        (item) => item.value === data.categoryId
      );
      formik.setFieldValue("categoryId", abcd.value);
      formik.setFieldValue("imageId", data.imageId);
      formik.setFieldValue("multimediaType", data.multimediaType);
      formik.setFieldValue("imageName", data.imageName);
      // setFileNamePreview(data.url.split('/').pop().split('-').slice(1).join('-'));
      if (data.parallax4DList.length > 0) {
        setFileName(
          data.parallax4DList.map((item) =>
            item.split("/").pop().split("-").slice(1).join("-")
          )
        );
      }
      setShowVal(data.isPremium === true ? "PREMIUM" : "NON PREMIUM");
      setShowVal2(abcd.label);
      if (CollectionOption?.length > 0 && data.collectionId) {
        const collectionItem = CollectionOption.find(
          (item) => item.value === data.collectionId
        );
        if (collectionItem) {
          formik.setFieldValue("collectionId", collectionItem.value);
          setShowVal3(collectionItem.label);
        }
      }
    }
  }, [location, data]);

  const initialValue = {
    imageId: "",
    categoryId: "",
    imageName: "",
    premium: false,
    previewImage: [],
    image: "",
    multiFile: [],
    collectionId: "",
  };

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter image name"),
    previewImage:
      location.state === null && yup.mixed().required("Please select image"),
    premium: yup.boolean().required("Please select image type"),
    // categoryId: yup.string().required("Please select image category"),
  });

  const submit = async (values, action) => {
    const {
      categoryId,
      imageName,
      premium,
      previewImage,
      imageId,
      collectionId,
    } = values;
    try {
      const fileData = new FormData();
      previewImage.map((item) => fileData.append("liveWallpapers", item));
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      fileData.append("premium", premium);
      fileData.append("collectionId", collectionId || 0);
      if (imageId) {
        fileData.append("id", imageId);
      }
      fileData.append("sendNotification", notification);
      setLoader();
      await liveWallpaperService.createLiveMultImages(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess(
        imageId
          ? "wallpaper update successfully"
          : "wallpaper create successfully"
      );
      setImageUpdate(false);
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate(-1);
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="pt-10">
            <h1 className="text-base font-semibold leading-7 text-white pb-5">
              Multi Live Wallpapers
            </h1>
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              name="imageName"
              placeholder="image name"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* First Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect(value, id)}
              selectedValue={showVal}
            />
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm mb-4">
                {formik.errors.premium}
              </div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm mb-4">
                {formik.errors.categoryId}
              </div>
            )}
          </div>

          {/* Third Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Image</label>
            <div className="flex items-center gap-5">
              <input type="image" accept="image/*" id="upload" alt="" hidden />
              <label
                onClick={handleClick}
                className="border border-white rounded-6 flex items-center justify-center flex-col gap-5 p-4 cursor-pointer w-full lg:p-10 text-center"
              >
                <BsImage className="text-gray-600 text-5xl" />
                <span className="text-white text-sm">
                  {fileNamePreview.length === 0 ? (
                    <>
                      <span className="text-center">
                        <strong>Upload a file</strong> or drag and drop <br />
                        mp4
                      </span>
                    </>
                  ) : (
                    fileNamePreview.length + " file uploaded"
                  )}
                </span>
              </label>
              <input
                type="file"
                onChange={handleChangePreview}
                ref={hiddenFileInput}
                className="hidden"
                accept="video/*"
                multiple
              />
            </div>
            {formik.errors.previewImage && formik.touched.previewImage && (
              <div className="text-red text-sm mb-4">
                {formik.errors.previewImage}
              </div>
            )}
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default MultiWallpaper;
